import React from 'react'

import PropTypes from 'prop-types'

import './contact10.css'

const Contact10 = (props) => {
  return (
    <div id="Kontakty" className="contact10-container thq-section-padding">
      <div id="Kontaktyy" className="contact10-max-width thq-section-max-width">
        <div className="contact10-content thq-flex-row">
          <div className="contact10-content1">
            <h2 className="contact10-text thq-heading-2">{props.heading1}</h2>
            <p className="thq-body-large">{props.content1}</p>
          </div>
        </div>
        <div className="contact10-content2 thq-flex-row">
          <div className="contact10-container1">
            <img
              alt={props.location1ImageAlt}
              src={props.location1ImageSrc}
              className="contact10-image thq-img-ratio-16-9"
            />
            <h3 className="contact10-text2 thq-heading-3">{props.location1}</h3>
            <p className="thq-body-large">{props.location1Description}</p>
          </div>
          <div className="contact10-container2">
            <img
              alt={props.location2ImageAlt}
              src={props.location2ImageSrc}
              className="contact10-image1 thq-img-ratio-16-9"
            />
            <h3 className="contact10-text4 thq-heading-3">{props.location2}</h3>
            <p className="thq-body-large">{props.location2Description}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

Contact10.defaultProps = {
  location1ImageAlt: 'Email Icon',
  location1: 'info@ivanasulcova.cz',
  location2Description:
    'Zavolejte mi během pracovních hodin pro okamžitou konzultaci vašeho současného stavu',
  location2ImageSrc:
    'https://images.unsplash.com/photo-1523966211575-eb4a01e7dd51?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDI1fHx0ZWxlZm9ufGVufDB8fHx8MTcyMDI4MTI1MHww&ixlib=rb-4.0.3&w=1400',
  location1ImageSrc:
    'https://images.unsplash.com/photo-1557200134-90327ee9fafa?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDF8fGVtYWlsfGVufDB8fHx8MTcyMDI4MTIxMHww&ixlib=rb-4.0.3&w=1400',
  location2: 'telefon: (+420) 606 912 729',
  content1: '',
  heading1:
    'Odhalte tajemství numerologie a nechte si sestavit numeroskop na základě rozboru vašeho data narození.',
  location2ImageAlt: 'Phone Icon',
  location1Description: 'Nezávazně si vyžádejte konzultaci',
}

Contact10.propTypes = {
  location1ImageAlt: PropTypes.string,
  location1: PropTypes.string,
  location2Description: PropTypes.string,
  location2ImageSrc: PropTypes.string,
  location1ImageSrc: PropTypes.string,
  location2: PropTypes.string,
  content1: PropTypes.string,
  heading1: PropTypes.string,
  location2ImageAlt: PropTypes.string,
  location1Description: PropTypes.string,
}

export default Contact10
